import { http } from "~/utils";
export default {
    getWbss: async (page = 1, filters = {}) => {
        const request_filters = { ...filters, page };
        return http
            .get("/wbs/wbs/", {
                params: request_filters
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    get_sap_top_wbs_autocomplete: async search => {
        return http.get("/wbs/wbs/", { params: { search: search, autocomplete: "true", level: 1 } });
    },
    getWbsDetail: async wbs_id => {
        return http.get(`/wbs/wbs/${wbs_id}/`).then(response => response.data);
    }
};
